import { LogOnViewModel } from '../model/AccountModel';
import { Api } from './api';

class AccountApi extends Api {
	public constructor() {
		super();
	}

	public updateAgreementByOperator = async (): Promise<boolean> => {
		const url = this.getUrl('Account/UpdateAgreementByOperator', true);

		return await this.post<boolean>(url);
	};

	public logOn = async (model: LogOnViewModel): Promise<LogOnViewModel> => {
		const url = this.getUrl('Account/Login', true);
		const data = {
			model,
		};

		return await this.post<LogOnViewModel>(url, data);
	};
}

const accountApi = new AccountApi();

export { accountApi };
